(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["allstar-horizontal-slider-one"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  jQuery(".cardForEveryOne-carousel").owlCarousel({
    items: 1,
    margin: 20,
    loop: true,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    nav: false,
    dots: false,
    responsive: {
      0: { items: 1 },
      600: { items: 1 },
      1000: { items: 4 }
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["allstar-horizontal-slider-two"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  jQuery(".bestseller-carousel").owlCarousel({
    items: 1,
    margin: 20,
    loop: true,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    nav: false,
    dots: false,
    responsive: {
      0: { items: 1 },
      600: { items: 1 },
      1000: { items: 4 }
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["allstar-review"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  jQuery('#review').owlCarousel({
    loop: true,
    margin: 14,
    nav: true,
    dots: true,
    autoHeight: true,
    autoplay: true,
    autoplayTimeout: 4000,
    smartSpeed: 1000,
    // autoplay: 9000,
    // smartSpeed: 1000,
    responsive: {
      0: { items: 2 },
      600: { items: 2 },
      1000: { items: 6 }
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bestsellers"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    jQuery(".bestseller-carousel").owlCarousel({
      items: 1,              
      margin: 20,            
      loop: true,            
      autoplay: true,        
      autoplayTimeout: 3000, 
      autoplayHoverPause: true,
      nav: false,            
      dots: false,           
      responsive: {
        0: { items: 1 }, 
        600:{
              items:1
        },
        1000:{
            items:5
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["card-for-everyone"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    jQuery(".cardForEveryOne-carousel").owlCarousel({
      items: 1,              
      margin: 20,            
      loop: true,            
      autoplay: true,        
      autoplayTimeout: 3000, 
      autoplayHoverPause: true,
      nav: false,            
      dots: false,           
      responsive: {
        0: { items: 1 }, 
        600:{
              items:1
        },
        1000:{
            items:4
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["love-card-for-everyone"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  jQuery('.cardForEveryOne-carousel').owlCarousel({
    items: 1,
    margin: 20,
    loop: true,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    nav: false,
    dots: false,
    responsive: {
      0: { items: 1 },
      600: { items: 1 },
      1000: { items: 4 }
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["love-collections"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    jQuery(".bestseller-carousel").owlCarousel({
      items: 1,              
      margin: 20,            
      loop: true,            
      autoplay: true,        
      autoplayTimeout: 3000, 
      autoplayHoverPause: true,
      nav: false,            
      dots: false,           
      responsive: {
        0: { items: 1 }, 
        600:{
              items:1
        },
        1000:{
            items:4
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["love-testimonials"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  if (window.jQuery && jQuery('#love-review').length) {
    jQuery('#love-review').owlCarousel({
      loop: true,
      margin: 14,
      nav: false,
      dots: true,
      autoplay: 9000,
      smartSpeed: 1000,
      responsive: {
        0: { items: 1.65 },
        600: { items: 2 },
        1000: { items: 6 }
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pets-best-sellers"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    jQuery(".bestseller-carousel").owlCarousel({
      items: 1,              
      margin: 20,            
      loop: true,            
      autoplay: true,        
      autoplayTimeout: 3000, 
      autoplayHoverPause: true,
      nav: false,            
      dots: false,           
      responsive: {
        0: { items: 1 }, 
        600:{
              items:1
        },
        1000:{
            items:4
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pets-review"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  jQuery('#review').owlCarousel({
      loop:true,
      margin:14,
      height:true,
      nav:false,
      dots:true,
      autoplay: 9000,
      smartSpeed:1000,
      responsive:{
          0:{
              items:1.65
          },
          600:{
              items:2
          },
          1000:{
              items:6
          }
      }
  });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reaction-video"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
    const video = document.querySelector("#reaction-video");
    const playButton = document.querySelector(".play-video-icon");
    const playButtonWrapper = document.querySelector(".video-play-button");
    const customControll = document.querySelector(".video-controlls");
    const customControllPlay = document.querySelector(".icon-play");
    const customControllPause = document.querySelector(".icon-pause");

    let hasEverPlayed = false;

    // Click → restart + unmute
    playButton.addEventListener("click", () => {
        video.currentTime = 0;
        video.muted = false;
        video.controls = false;
        video.play();

        playButtonWrapper.style.display = "none";
        customControll.classList.add('active');
        
        //playButtonWrapper.style.backgroundColor = "transparent";
        hasEverPlayed = true;
    });

    // Viewport logic
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach(entry => {

                // ENTER viewport → autoplay (muted)
                if (entry.isIntersecting) {
                    if (!hasEverPlayed) {
                        video.muted = true;
                        video.play().catch(() => {});
                        hasEverPlayed = true;
                    }
                }

                // LEAVE viewport → pause
                else {
                    video.pause();
                }
            });
        },
        {
            threshold: 0.25 // plays when 25% visible
        }
    );

    observer.observe(video);

// 1. Play Button Click
customControllPlay.addEventListener("click", () => {
    video.play();
    customControll.classList.add('playing'); 
    customControll.classList.remove('pausing');
});

// 2. Pause Button Click
customControllPause.addEventListener("click", () => {
    video.pause();
    customControll.classList.remove('playing');
    customControll.classList.add('pausing'); 
});


});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  jQuery('#review').owlCarousel({
      loop:true,
      margin:14,
      height:true,
      nav:false,
      dots:true,
      autoHeight:true,
      autoplay: 9000,
      smartSpeed:1000,
      responsive:{
          0:{
              items:2
          },
          600:{
              items:2
          },
          1000:{
              items:3
          }
      }
  });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrollable-top-bar"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  jQuery('#top-bar-scroller').owlCarousel({
      loop:true,
      margin:0,
      height:true,
      nav:false,
      dots:false,
      autoHeight:true,
      autoplay: 9000,
      smartSpeed:1000,
      items:1
  });
  });

  } catch(e) { console.error(e); }
})();
})();
